import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import pointOfSale from "@faire/web-api--source/routes/www/point-of-sale";
import React, { type JSX } from "react";

export const PosIntegrationBanner: React.FC = () => {
  return (
    <Typography align="center">
      <ResponsiveContentV2
        noJS
        tabletAndBelow={
          <StrictLocalMsg
            defaultMessage="Connect your POS to Faire to easily manage your inventory. <LinkFormatting>Learn more</LinkFormatting>"
            values={{ LinkFormatting }}
          />
        }
        desktopAndAbove={
          <StrictLocalMsg
            defaultMessage="<MediumFormatting>Do you use Shopify, Square, or Clover?</MediumFormatting> Connect your POS to Faire to easily manage your inventory. <LinkFormatting>Learn more</LinkFormatting>"
            values={{ MediumFormatting, LinkFormatting }}
          />
        }
      />
    </Typography>
  );
};

const LinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={pointOfSale()}>
    {chunks}
  </Button>
);
